import { render, staticRenderFns } from "./GradientPage.vue?vue&type=template&id=55723b79&scoped=true&"
import script from "./GradientPage.vue?vue&type=script&lang=js&"
export * from "./GradientPage.vue?vue&type=script&lang=js&"
import style0 from "./GradientPage.vue?vue&type=style&index=0&id=55723b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55723b79",
  null
  
)

export default component.exports